import {
  AfsPlacementId,
  ConsentStatus,
  ExperimentVariants,
  FinnLegendaryAfsPlacementId,
  Vertical
} from '@schibsted-nmp/advertising-shared';
import { $amplitudeExperimentsAtom } from '@client/core/atoms/amplitude.js';

import { $config } from '../../core/atoms/config.js';

const experimentChannels: Record<string, string> = {
  [ExperimentVariants.Control]: '9045796715',
  [ExperimentVariants.Treatment_1]: '8512386191',
  [ExperimentVariants.Treatment_2]: '9937697245'
};

export default function getAfsChannel(
  placementId: AfsPlacementId | FinnLegendaryAfsPlacementId
): string {
  // Custom channels can be edited at adsense.google.com
  const channelsConfigMap = {
    finn: {
      vertical: {
        [Vertical.Recommerce]: '1541148774'
      },
      consent: {
        [ConsentStatus.Accepted]: '4684201339',
        [ConsentStatus.Rejected]: '9888426555'
      },
      placement: {
        [AfsPlacementId.AfsContainer1]: '3018295631',
        [AfsPlacementId.AfsContainerBottom]: '2926989810'
      }
    },
    dba: {
      vertical: {
        [Vertical.Recommerce]: '7595169273',
        [Vertical.Mobility]: '6282087601'
      },
      consent: {
        [ConsentStatus.Accepted]: '5124122443',
        [ConsentStatus.Rejected]: '5399454618'
      },
      placement: {
        [AfsPlacementId.AfsContainer1]: '1460209601',
        [AfsPlacementId.AfsContainerBottom]: '4386552005'
      }
    },
    tori: {
      vertical: {
        [Vertical.Recommerce]: '6734179364'
      },
      consent: {
        [ConsentStatus.Accepted]: '9803002315',
        [ConsentStatus.Rejected]: '1972613759'
      },
      placement: {
        [AfsPlacementId.AfsContainer1]: '4031994407',
        [AfsPlacementId.AfsContainerBottom]: '5839706570'
      }
    }
  };

  try {
    const config = $config.get();
    const { brand, consent, vertical } = config ?? {};

    const isMobility = ['car', 'boat'].includes(vertical as string);
    const verticalAdjusted = isMobility ? Vertical.Mobility : vertical;

    const brandConfig =
      channelsConfigMap[brand as keyof typeof channelsConfigMap];

    const consentMap = brandConfig.consent;
    const consentChannel = consent ? consentMap[consent] : '';

    const verticalMap = brandConfig.vertical;
    const verticalChannel =
      verticalMap[verticalAdjusted as keyof typeof verticalMap];

    const placementMap = brandConfig.placement;
    const placementChannel =
      placementMap[placementId as keyof typeof placementMap];

    const { experiments } = $amplitudeExperimentsAtom.get();
    const experimentVariant = experiments['advt-adsense-context-dba'];
    const hasExperimentChannel = experimentVariant && isMobility;
    const experimentChannel = hasExperimentChannel
      ? [experimentChannels[experimentVariant]]
      : [];

    const channelsString = [
      consentChannel,
      verticalChannel,
      placementChannel,
      ...experimentChannel
    ]
      .filter(Boolean)
      .join('+');

    return channelsString;
  } catch (error) {
    const message = 'Failed to get AFS channels:';
    console.error(message, error);
    return '';
  }
}
